export default "__VITE_ASSET__hWJNgmne__"